<!--
 * @Descripttion: 
 * @version: 
 * @Author: 
 * @Date: 2026-01-09 15:36:12
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2026-01-14 10:01:28
-->
<template>
    <div class="transactionbox sm-qu-padding">
        <div class="transaction-tabs">
            <div class="ttab-box">
                <el-radio-group v-model="activeTabName">
                    <el-radio-button label="cards">{{ $t('SubAccount.TransactionTabVirtualCards') }}</el-radio-button>
                    <el-radio-button label="accounts">{{ $t('SubAccount.TransactionTabAccounts') }}</el-radio-button>
                </el-radio-group>
            </div>
            <div v-show="activeTabName === 'cards'">
                <CTableWrapper
                :items="data"
                hover
                striped
                border
                small
                fixed
                dark
                @searchData="getData"
                :pages="pages"
                :isSubAccount="true"
                caption="Combined All dark Table"
                />
            </div>
            <div v-show="activeTabName === 'accounts'">
                <CTableAccountWrapper
                    :items="subAcconts"
                    hover
                    striped
                    border
                    small
                    fixed
                    dark
                    @searchData="initData"
                    :pages="accountPages"
                    :isSubAccount="true"
                    caption="Combined All dark Table"
                    />
            </div>
            <!-- <el-tabs v-model="activeTabName">
                <el-tab-pane :label="$t('SubAccount.TransactionTabVirtualCards')" name="cards">
                    <div>
                        <CTableWrapper
                        :items="data"
                        hover
                        striped
                        border
                        small
                        fixed
                        dark
                        @searchData="getData"
                        :pages="pages"
                        :isSubAccount="true"
                        caption="Combined All dark Table"
                        />
                    </div>
                </el-tab-pane>
                <el-tab-pane :label="$t('SubAccount.TransactionTabAccounts')" name="accounts">
                    <CTableAccountWrapper
                    :items="subAcconts"
                    hover
                    striped
                    border
                    small
                    fixed
                    dark
                    @searchData="initData"
                    :pages="accountPages"
                    :isSubAccount="true"
                    caption="Combined All dark Table"
                    />
                </el-tab-pane>
            </el-tabs> -->
        </div>
    </div>
</template>

<script>
import CTableWrapper from '../../components/ConsumerTable.vue'
import CTableAccountWrapper from '../../components/AccountFlowTable.vue'
import {getCardDetail, getTransctionDetail} from "../../api/http"
export default {
    components: { CTableWrapper, CTableAccountWrapper },
    data() {
        return {
            activeTabName: 'cards',
            data: [
                // {
                //     id: 10,
                //     trans_id: '0bdyej-3hkjse-hjhksd',
                //     status: 'Declined',
                //     card_number: '4288373912268568',
                //     card_id: '83yadw-8das-hhajk1-fhakj',
                //     auth_time: '2022-09-10 10:09:07',
                //     auth_amt: "-25.00",
                //     auth_currency: 'USD',
                //     settle_time: '2022-09-10 10:09:07',
                //     settle_amt: '-25.00',
                //     settle_currency: 'USD',
                //     merchant_name: 'GOOGLE*PLAY',
                //     type: 'Authorization',
                //     decline_reason: 'LIMIT_EXCEEDED',
                //     remark: null,
                //     tag: 'Edward Powers',
                //     alias: 'Edward Powers'
                // },
                // {
                //     id: 11,
                //     trans_id: '0bgej-3hkjse-554hksd',
                //     status: 'Declined',
                //     card_number: '4288373912268568',
                //     card_id: '83yfdsdw-8das-hhajk3-fhr2akj',
                //     auth_time: '2022-09-10 10:09:07',
                //     auth_amt: "-25.00",
                //     auth_currency: 'USD',
                //     settle_time: '2022-09-10 10:09:07',
                //     settle_amt: '-25.00',
                //     settle_currency: 'USD',
                //     merchant_name: 'GOOGLE*PLAY',
                //     type: 'Authorization',
                //     decline_reason: 'LIMIT_EXCEEDED',
                //     remark: null,
                //     tag: 'Edward Powers',
                //     alias: 'Edward Powers'
                // }
            ],
            subAcconts: [],
            accountPages: 0,
            pages: null,
            data1: [
                {
                    alias: "Jone",
                    auth_time: '2021/11/01 12:00:23',
                    merchant_name: 'Amazon Payments',
                    // ConsumerCard: 'Maurice Sevilla 1231231231231231231',
                    ConsumerCard: {
                        name: 'Maurice Sevilla',
                        code: '1231231231231231231'
                    },
                    card_number: "22292988888888888",
                    auth_amt: -20,
                    auth_currency: 'USD',
                    settle_amt: -20,
                    settle_currency: -20,
                    type: '消費授權',
                    status: 'Pending'
                },
                {
                    alias: "Jone",
                    auth_time: '2021/11/01 12:00:23',
                    merchant_name: 'Amazon Payments',
                    // ConsumerCard: 'Maurice Sevilla 1231231231231231231',
                    ConsumerCard: {
                        name: 'Maurice Sevilla',
                        code: '1231231231231231231'
                    },
                    card_number: "42883788888888888",
                    auth_amt: -20,
                    auth_currency: 'USD',
                    settle_amt: -20,
                    settle_currency: -20,
                    type: '消費授權',
                    status: 'Decline'
                },
                {
                    alias: "Jone",
                    auth_time: '2021/11/01 12:00:23',
                    merchant_name: 'Amazon Payments',
                    // ConsumerCard: 'Maurice Sevilla 1231231231231231231',
                    ConsumerCard: {
                        name: 'Maurice Sevilla',
                        code: '1231231231231231231'
                    },
                    card_number: "42883788888888888",
                    auth_amt: -20,
                    auth_currency: 'USD',
                    settle_amt: -20,
                    settle_currency: -20,
                    type: '消費授權',
                    status: 'Decline'
                },
                {
                    alias: "Jone",
                    auth_time: '2021/11/01 12:00:23',
                    merchant_name: 'Amazon Payments',
                    // ConsumerCard: 'Maurice Sevilla 1231231231231231231',
                    ConsumerCard: {
                        name: 'Maurice Sevilla',
                        code: '1231231231231231231'
                    },
                    card_number: "42883788888888888",
                    auth_amt: -20,
                    auth_currency: 'USD',
                    settle_amt: -20,
                    settle_currency: -20,
                    type: '消費授權',
                    status: 'Decline'
                },{
                    alias: "Jone",
                    auth_time: '2021/11/01 12:00:23',
                    merchant_name: 'Amazon Payments',
                    // ConsumerCard: 'Maurice Sevilla 1231231231231231231',
                    ConsumerCard: {
                        name: 'Maurice Sevilla',
                        code: '1231231231231231231'
                    },
                    auth_amt: -20,
                    auth_currency: 'USD',
                    settle_amt: -20,
                    settle_currency: -20,
                    type: '消費授權',
                    status: 'Decline'
                }
            ]
        }
    },
    created() {
        this.initData()
    },
    methods: {
        // 获取子账户虚拟卡记录记录
        getData(before, after, card_number, tag, status,merchant_name, sub_user_name, page) {
           let data = {
                type: "get_subaccount_card_transaction",
                uid: window.localStorage.getItem("uid"),
                before: before || "",
                after: after || "",
                card_number: card_number || "",
                tag: tag || "",
                status: status || "",
                // ttype: ttype || "",
                merchant_name: merchant_name || '',
                sub_user_name: sub_user_name || '', // 子账户名称
                page: page || 1,
                page_size: 20,
                // sub_uid: '', // 子账户ID
                
            }
            getCardDetail(data).then(res => {
                // console.log('res==>', res)
                this.pages = Number(res.size)
                this.data = res.data
            })
        },
        // 获取子账户明细中的账户数据
        initData(before,after,card_number,atype,sub_user_name,page) {
            let data = {
                type: "get_subaccount_account_transaction",
                uid: window.localStorage.getItem("uid"),
                before: before || "",
                after: after || "",
                card_number: card_number || "",
                atype: atype || "",
                sub_user_name: sub_user_name || '',
                page: page ||  1,
                page_size: 20
            }
            getTransctionDetail(data).then((res) => {
                // console.log('detail res==>', res)
                this.accountPages = Number(res.data.size)
                this.subAcconts = res.data.data
            })
        }
    }
}
</script>

<style scoped>
.transactionbox {
    padding-left: 2.5rem;
    overflow: hidden;
}
::v-deep .el-tabs__nav-scroll {
    padding-left: 10px;
}
::v-deep .el-tabs__active-bar {
    background-color: #00BEA4;
}
::v-deep .el-tabs__item.is-active {
    color: #00BEA4;
}
::v-deep .el-tabs__nav-wrap::after {
    height: 1px;
    background-color: #f1f1f2;
}
::v-deep .el-tabs__item:hover {
    color: #00BEA4;
}
.transaction-tabs {
    background-color: #fff;
}
::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner {
    background-color: #00BEA4;
    border-color: #00BEA4;
    color: #fff;
}
::v-deep .el-radio-button__inner:hover {
    color: #00BEA4;
}
.ttab-box {
    padding-top: 10px;
    padding-left: 10px;
    border-bottom: 1px solid #eee;
}
</style>